import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss'],
})
export class FormFooterComponent {
  @Input() public changesWereDone = false;
  @Output() public resetChanges: EventEmitter<void> = new EventEmitter<void>();
  @Output() public cancelSettings: EventEmitter<void> = new EventEmitter<void>();
  @Output() public saveChanges: EventEmitter<void> = new EventEmitter<void>();

  public resetChangesClicked() {
    this.resetChanges.emit();
  }

  public cancelSettingsClicked() {
    this.cancelSettings.emit();
  }

  public saveChangesClicked() {
    this.saveChanges.emit();
  }
}
